export default __webpack_public_path__ + "static/media/1_0038.63955657.webp";